import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c5d0745"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-out" }
const _hoisted_2 = { class: "detail-container" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { class: "item-name" }
const _hoisted_6 = { class: "item-time" }
const _hoisted_7 = { class: "right" }
const _hoisted_8 = { class: "status-wrap" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "no-data"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, null, -1))

import { useRouter, useRoute } from 'vue-router'
import AppHeader from '@/components/Header.vue'
import jumpIcon from '@/assets/my-credentails/jump-icon.svg'
import rightArrow from '@/assets/my-credentails/progress-arrow.svg'
import { clearToast } from '@/utils/tools'
import { PullRefresh, Dialog } from 'vant'
import { onMounted, watch, ref } from 'vue'
import AppHost from '@/utils/app'
import { getCredentialsApplyLog } from '@/apis/my-credentials'
import { Toast } from 'vant'
import wxHost from '@/utils/wx'
type listDataItemType = {
  name: string
  time: string
  status: number
  statusText: string
  guid: string
  type: number
  pay_order_no: string
}


import { defineComponent } from 'vue'
import { useStore } from 'vuex'

const __default__ = defineComponent({
  name: 'credentials-detail',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const $store = useStore()
const $router = useRouter()
const $route = useRoute()

const refreshing = ref(false)

const StatusColorObj: { [index: string]: string } = {
  10: '#F7981C',
  20: '#F7981C',
  30: '#F85359',
  40: '#F7981C',
  50: '#F7981C',
  56: '#aaa',
  60: '#00C378',
}

async function initData() {
  try {
    let data = await getCredentialsApplyLog()
    console.log('initData', data)
    listData.value = (data || []).map((_) => {
      return {
        name: _.type_text,
        time: _.created_at,
        status: _.status,
        statusText: _.status_text,
        guid: _.guid,
        type: _.type,
        pay_order_no: _.pay_order_no,
      }
    })
  } catch (e) {
    console.log('initData')
  }
}

async function onRefresh() {
  try {
    await initData()
  } catch (e) {
    console.log('onRefresh', e)
  }
  refreshing.value = false
}

const listData = ref<Array<listDataItemType>>([])

const gotoHandle = (item: listDataItemType) => {
  console.log('gotoHandle')
  // 环境判断
  if (!wxHost.isMiniprogram) {
    Dialog.alert({
      title: '提示',
      className: 'tip-dialog',
      message: '请前【极飞服务】小程序查看证件办理进度。',
      confirmButtonColor: 'rgba(0, 195, 120, 1)',
      confirmButtonText: '知道了',
    })
  } else {
    let url = ''
    // 跳转到小程序
    switch (item.status) {
      case 10: // 待支付
        url = '/pages/user/pay?guid=' + item.pay_order_no
        break
      case 20: // 待审核
        url = '/pages--train/my_license_apply_progress?types=' + item.type + '&guid=' + item.guid
        break
      case 30: // 审核不通过
        url = '/pages--train/my_license_apply_form_again?types=' + item.type + '&guid=' + item.guid
        break
      case 40: // 待寄回
        url = '/pages--train/my_license_apply_progress?types=' + item.type + '&guid=' + item.guid
        break
      case 50: // 待接收
        url =
          '/pages--train/my_license_apply_progress_sure?types=' + item.type + '&guid=' + item.guid
        break
      case 60: // 已完成
        url = '/pages--train/my_license_apply_progress?types=' + item.type + '&guid=' + item.guid
        break
      case 55: // 拒绝退款
        url =
          '/pages--train/my_license_apply_refund_again?types=' + item.type + '&guid=' + item.guid
        break
    }
    AppHost.openMiniProgram('gh_68b32d3107f6', url, process.env.NODE_ENV === 'production' ? 0 : 1)
  }
}

onMounted(async () => {
  clearToast()
  let toast = Toast({
    type: 'loading',
    message: '获取数据中...',
    forbidClick: true,
    duration: 0,
  })
  refreshing.value = true
  try {
    await initData()
  } catch (e) {
    console.log('onMounted', e)
  }
  refreshing.value = false

  toast.clear()
})

function leftClickHandle() {
  $router.replace({
    name: 'my-credentials-detail',
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      class: "progress-header",
      title: "进度查询",
      isReturnLeftEvent: true,
      onLeftClick: leftClickHandle
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(PullRefresh), {
        modelValue: refreshing.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refreshing).value = $event)),
        onRefresh: onRefresh,
        class: _normalizeClass(["detail-wrap", { isEmpty: !listData.value.length }])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listData.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item van-hairline--bottom",
                key: index,
                onClick: ($event: any) => (gotoHandle(item))
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1),
                  _createElementVNode("div", _hoisted_6, "申请时间：" + _toDisplayString(item.time), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", {
                      class: "item-stauts",
                      style: _normalizeStyle({ color: StatusColorObj[item.status] })
                    }, _toDisplayString(item.statusText), 5),
                    _createElementVNode("img", {
                      width: "16",
                      height: "16",
                      src: _unref(rightArrow)
                    }, null, 8, _hoisted_9)
                  ])
                ])
              ], 8, _hoisted_3))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "class"])
    ]),
    (!listData.value.length && !refreshing.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, "当前暂无申请单据！"))
      : _createCommentVNode("", true),
    _hoisted_11
  ], 64))
}
}

})